/*
 * @Author: tanyaohua 
 * @Date: 2021-04-Th 10:10:55 
 * @Last Modified by:   mikey.zhaopeng 
 * @Last Modified time: 2021-04-Th 10:10:55 
 */
'use strict';
angular.module('roleManageMentIframeModule', [])
    .controller('roleManageMentIframeCtrl', ['$scope',
        function($scope) {
            $scope.stSrc = '/newmanageconfig/#/rolemanage';
        }
    ]);
